<template>
  <div class="chat-container">
    <div class="chat-messages" ref="chatContainer">
      <div v-for="(message, index) in messages" :key="index" :class="['message', message.role]">
        <div class="message-content">
          {{ message.content }}
        </div>
        <div v-if="message.attachment" class="attachment">
          <el-image :src="message.attachment" :preview-src-list="[message.attachment]">
            <template #error>
              <div class="image-slot">
                <el-icon><icon-picture /></el-icon>
              </div>
            </template>
          </el-image>
        </div>
      </div>
    </div>
    
    <div class="chat-input">
      <el-input
        v-model="userInput"
        type="textarea"
        :rows="3"
        placeholder="输入消息..."
        @keyup.enter="sendMessage"
      />
      <div class="input-actions">
        <el-upload
          class="upload-demo"
          action="#"
          :auto-upload="false"
          :on-change="handleFileChange"
          :show-file-list="false"
        >
          <el-button type="primary" icon="el-icon-paperclip">添加附件</el-button>
        </el-upload>
        <el-button type="primary" @click="sendMessage" :loading="loading">发送</el-button>
      </div>
    </div>

    <el-drawer
      v-model="drawerVisible"
      title="配置"
      direction="btt"
      :with-header="false"
      size="auto"
    >
      <div class="drawer-content">
        <h3>模型配置</h3>
        <el-form :model="config" label-width="100px">
          <el-form-item label="模型类型">
            <el-select v-model="config.modelType">
              <el-option label="GPT-3.5" value="gpt-3.5-turbo" />
              <el-option label="GPT-4" value="gpt-4" />
            </el-select>
          </el-form-item>
          <el-form-item label="温度">
            <el-slider v-model="config.temperature" :min="0" :max="1" :step="0.1" />
          </el-form-item>
          <!-- 可以根据需要添加更多配置项 -->
        </el-form>
      </div>
    </el-drawer>

    <div class="drawer-toggle" @click="drawerVisible = !drawerVisible">
      <el-icon><ArrowUp v-if="!drawerVisible" /><ArrowDown v-else /></el-icon>
      配置
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { ArrowUp, ArrowDown, Picture as IconPicture } from '@element-plus/icons-vue'

const userInput = ref('')
const messages = ref([])
const loading = ref(false)
const chatContainer = ref(null)
const drawerVisible = ref(false)
const config = ref({
  modelType: 'gpt-3.5-turbo',
  temperature: 0.7
})

const sendMessage = async () => {
  if (!userInput.value.trim()) return

  const userMessage = {
    role: 'user',
    content: userInput.value
  }

  messages.value.push(userMessage)
  userInput.value = ''

  loading.value = true
  // 这里应该调用实际的 AI API
  await new Promise(resolve => setTimeout(resolve, 2000))
  
  const aiResponse = {
    role: 'assistant',
    content: '这是一个 AI 生成的回复示例。'
  }
  messages.value.push(aiResponse)
  loading.value = false

  await nextTick()
  scrollToBottom()
}

const handleFileChange = (file) => {
  const reader = new FileReader()
  reader.onload = (e) => {
    messages.value.push({
      role: 'user',
      content: '发送了一个附件',
      attachment: e.target.result
    })
    scrollToBottom()
  }
  reader.readAsDataURL(file.raw)
}

const scrollToBottom = () => {
  if (chatContainer.value) {
    chatContainer.value.scrollTop = chatContainer.value.scrollHeight
  }
}

onMounted(() => {
  scrollToBottom()
})
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  padding: 20px;
  box-sizing: border-box;
}

.chat-messages {
  flex-grow: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #1e1e1e;
  border-radius: 8px;
}

.message {
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 8px;
  max-width: 70%;
}

.user {
  align-self: flex-end;
  background-color: #4a4a4a;
  margin-left: auto;
}

.assistant {
  align-self: flex-start;
  background-color: #2a2a2a;
  margin-right: auto;
}

.chat-input {
  display: flex;
  flex-direction: column;
}

.input-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.drawer-content {
  padding: 20px;
}

.drawer-toggle {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #2a2a2a;
  padding: 10px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.attachment {
  margin-top: 10px;
}

.attachment .el-image {
  max-width: 200px;
  max-height: 200px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
</style>